import { Button, Card, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addComment } from '../../../../appRedux/actions';
import {
  buttonLabel,
  cardConfig,
  formConfig,
  messages,
} from '../../../../constants';

export const AddCommentModalBody = ({ appointment, setIsModalOpen }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [response, setResponse] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isBefore, setIsBefore] = useState(false);

  useEffect(() => {
    setIsBefore(
      moment(`${appointment?.date} ${appointment?.endTime}`).isBefore(moment())
    );
  }, [appointment]);

  useEffect(() => {
    if ([200, 201].includes(response)) {
      setIsModalOpen(false);
    }
  }, [response, dispatch, setIsModalOpen]);

  useEffect(() => {
    if (appointment?.observations) {
      form.setFieldsValue({
        comment: appointment.observations,
      });
    }
  }, [form, appointment]);

  const onSubmit = async (formValues) => {
    setIsLoading(true);
    setResponse(
      await dispatch(
        addComment(appointment.id, formValues)
      )
    );
    setIsLoading(false);
  };

  return (
    <Card size="small" bordered={true} style={cardConfig}>
      <Form
        autoComplete="off"
        onFinish={onSubmit}
        form={form}
        disabled={isBefore}
        {...formConfig}
      >
        <Form.Item
          name="comment"
          disabled={isBefore === true}
          rules={[
            {
              required: true,
              message: messages.required('Comentario'),
            },
          ]}
        >
          <TextArea rows={5} />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          className="btn-form"
          loading={isLoading}
        >
          {buttonLabel.save}
        </Button>
      </Form>
    </Card>
  );
};
